export default __webpack_public_path__ + "assets/ItemImagePlaceholder.c0d00487.webp";